import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAllRates } from "../../modules/taxiModuleRates";

export const fetchTaxiModuleRates = createAsyncThunk(
  "taxiModuleRates/fetchTaxiModuleRates",
  async (arg, thunkAPI) => {
    try {
      const response = await getAllRates(arg);
      return response;
    } catch (e) {
      console.log("Error", e.response.data);
      return thunkAPI.rejectWithValue(e.response.data);
    }
  }
);
